import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";

const Transactions = () => {
    const [withdrawals, setWithdrawals] = useState([]);
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow);
    };

    useEffect(() => {
        const fetchWithdrawals = async () => {
            try {
                const response = await fetch(`${API_URL}/authors/withdrawals`, {
                    headers: { 'Authorization': `Bearer ${token()}` }
                });
                const data = await response.json();
                if (response.ok && data.withdrawals) {
                    setWithdrawals(data.withdrawals);
                }
            } catch (error) {
                console.error('Error fetching withdrawals:', error);
            }
        };

        fetchWithdrawals();
    }, []);

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />
                        <div className="container">
                            <div className="page-inner">
                                <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                    <h3 className="fw-bold mb-3">Withdrawal History</h3>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="table-responsive pt-3">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Amount</th>
                                                            <th>Status</th>
                                                            <th>Cleared At</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {withdrawals.map((w, index) => (
                                                            <tr key={index}>
                                                                <td>{new Date(w.requested_at).toLocaleDateString()}</td>
                                                                <td>${w.amount}</td>
                                                                <td>
                                                                    <span className={`badge ${w.status === 'cleared' ? 'bg-success' : 'bg-warning'}`}>
                                                                        {w.status}
                                                                    </span>
                                                                </td>
                                                                <td>{w.cleared_at ? new Date(w.cleared_at).toLocaleDateString() : '—'}</td>
                                                            </tr>
                                                        ))}
                                                        {withdrawals.length === 0 && (
                                                            <tr><td colSpan="4" className="text-center">No withdrawals yet</td></tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default Transactions;